// extracted by mini-css-extract-plugin
module.exports = {"main":"Colors_main__1MUJg","selected":"Colors_selected__3Sz8a"};